import { Table, Row, Col, Select, Button, notification, Tooltip } from 'antd'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './App.css'
import { ReloadOutlined } from '@ant-design/icons'
import moment from 'moment'

// var _ = require('lodash');

function App() {
  const [filterData, setFilterData] = useState([])
  const [tableLoading, setTableLoading] = useState(true)
  const [ceCoi, setCeCoi] = useState('')
  const [peCoi, setPeCoi] = useState('')
  // const [pageSize, setPageSize] = useState("")
  const [selectData, setSelectData] = useState('')
  const [isSelect, setIsSelect] = useState(false)
  const [expiryDate, setExpiryDate] = useState('')
  const [tableTime, setTableTime] = useState('')
  const [underLyingValue, setUnderLyingValue] = useState('')
  const [ceCoiData, setCeCoiData] = useState([])
  const [peCoiData, setPeCoiData] = useState([])
  const [timeStamp, setTimeStamp] = useState([])
  const [strikePriceArray, setStrikePriceArray] = useState([])
  const [getClosest, setGetClosest] = useState("")

  const { Option } = Select

  function onChange(value) {
    // console.log(`selected ${value}`);
    setIsSelect(true)
    getNifty50(value)
    setInterval(() => {
      getNifty50(value)
    }, 90000);
  }
  // console.log("Morning--", moment().format('LT') > "9:17 AM" ? true : false)
  // console.log("AfterNoon--", moment().format('LT') < "3:15 PM" ? true : false)


  function onSearch(val) {
    // console.log('search:', val);
  }

  const openNotification = () => {
    if (selectData == '') {
      const btn = (
        <Button
          type='primary'
          size='small'
          onClick={() => window.location.reload()}
        >
          Click here to Reload
        </Button>
      )
      notification['warning']({
        message: 'Error to Fetch Data',
        description:
          'There is Some Error to Fetch Data. Please Reload this Page',
        // icon: <SmileOutlined style={{ color: '#108ee9' }} />,
        btn,
        placement: 'top',
        duration: 10,
      })
    }
  }

  const tableHeader = () => (
    <div className='tbl-head'>
      <div>
        <b>Name:</b> {selectData}
      </div>
      <div>
        <b>Expiry:</b> {expiryDate}
      </div>

      <div>
        <b>{underLyingValue}</b>
      </div>

      <div>
        <b>Time & Data:</b> {tableTime}
      </div>
    </div>
  )



  const getNifty50 = (value) => {
    setTableLoading(true)
    const config = {
      headers: {
        'access-control-allow-headers': 'Content-Type',
        'access-control-allow-methods': 'GET,POST',
        'access-control-allow-origin': 'nseindia.com',
      },
    }
    setSelectData(value)

    return axios
      .get(
        `https://www.nseindia.com/api/option-chain-indices?symbol=${value}`,
        config
      )
      .then((res) => {
        // console.log(res.data.filtered.data.map((item) => item.CE.changeinOpenInterest))
        // console.log("Response--", res.data)
        setTableLoading(false)
        setTableTime(res.data.records.timestamp)
        setUnderLyingValue(res.data.records.underlyingValue)
        setFilterData(res.data.filtered.data)
        // setPageSize(res.data.filtered.data)
        setExpiryDate(res.data.filtered.data[0].expiryDate)
        setStrikePriceArray(res.data.filtered.data.map((item) => item.strikePrice))

        let timeStamparray = []
        timeStamparray.push(res.data.records.timestamp)
        setTimeStamp(timeStamparray)

        const filterDataArray = res.data.filtered.data.map((item) => {
          // console.log(item.CE.changeinOpenInterest)
          return item.CE.changeinOpenInterest
        })

        const filterPeDataArray = res.data.filtered.data.map((item) => {
          // console.log(item.CE.changeinOpenInterest)
          return item.PE.changeinOpenInterest
        })

        var cesum = filterDataArray.reduce(function (a, b) {
          return a + b
        }, 0)
        setCeCoi(cesum)

        var pesum = filterPeDataArray.reduce(function (a, b) {
          return a + b
        }, 0)
        setPeCoi(pesum)

        let ceOiarr = []
        ceOiarr.push(cesum)
        setCeCoiData(ceOiarr)

        let peOiarr = []
        peOiarr.push(pesum)
        setPeCoiData(peOiarr)

        const closest = res.data.filtered.data.map((item) => item.strikePrice)?.reduce((a, b) => {
          return Math.abs(b - res.data.records.underlyingValue) < Math.abs(a - res.data.records.underlyingValue) ? b : a;
        });
        // console.log("Close", closest);
        setGetClosest(closest)

        const divide = gettble2PeCoIdata(peOiarr) / gettble2CeCoIdata(ceOiarr)

        const getTable2Data = {
          ceOI: gettble2CeCoIdata(ceOiarr),
          peOI: gettble2PeCoIdata(peOiarr),
          timeStamp: res.data.records.timestamp,
          peCeRatio: gettble2PeCoIdata(peOiarr) / gettble2CeCoIdata(ceOiarr),
          byesell: divide > 1 ? "Buy" : "Sell",
        }
        if (localStorage.getItem("table2Data_" + value)) {
          let localData = localStorage.getItem("table2Data_" + value)
          localData = JSON.parse(localData)
          // console.log(res.data.records.timestamp, localData[localData.length - 1].timeStamp, "Condition")
          if (res.data.records.timestamp == localData[localData.length - 1].timeStamp) {
            return;
          }
          localStorage.setItem("table2Data_" + value, JSON.stringify([getTable2Data, ...localData]))
        } else {
          localStorage.setItem("table2Data_" + value, JSON.stringify([getTable2Data]))
        }
        // console.log("Table 2 Data--", getTable2Data)

      })
      .catch((err) => {
        // console.log("Error--", err)

        setSelectData('')
        setIsSelect(false)
        openNotification()
      })
  }

  const columns = [
    {
      title: 'Sr No',
      dataIndex: 'srno',
      key: 'srno',
    },
    {
      title: 'CE OI',
      dataIndex: 'ceOI',
      key: 'ceOI',
    },
    {
      title: 'CE CHNG IN OI',
      dataIndex: 'ce',
      key: 'ce',
    },
    // {
    //   title: 'CE VOLUME',
    //   dataIndex: 'ceVolume',
    //   key: 'ceVolume',
    // },
    {
      title: 'STRIKE PRICE',
      dataIndex: 'strikePrice',
      key: 'strikePrice',
      render: (text, record) => text == getClosest ? <b>{getClosest}</b> : text,

    },
    {
      title: 'PE OI',
      dataIndex: 'peOI',
      key: 'peOI',
    },
    {
      title: 'PE CHNG IN OI',
      dataIndex: 'pe',
      key: 'pe',
    },
    // {
    //   title: 'PE VOLUME',
    //   dataIndex: 'peVolume',
    //   key: 'peVolume',
    // },
  ]

  const columns2 = [
    {
      title: 'CE OI',
      dataIndex: 'ceOI',
      key: 'ceOI',
    },
    {
      title: 'PE OI',
      dataIndex: 'peOI',
      key: 'peOI',
    },
    {
      title: 'Time Stamp',
      dataIndex: 'timeStamp',
      key: 'timeStamp',
    },
    {
      title: 'PUT/CALL RATIO',
      dataIndex: 'peCeRatio',
      key: 'peCeRatio',
    },

    {
      title: 'BUY/SELL',
      dataIndex: 'byesell',
      key: 'byesell',
      render: (text, record) => text == "Sell" ? <span className='sell-text'> Sell </span> : <span className='buy-text'> Buy </span>
    },
  ]

  const gettble2CeCoIdata = (ceCoiData) => {
    const getCeOi = ceCoiData.map((item) => item)
    return getCeOi
  }

  const gettble2PeCoIdata = (peCoiData) => {
    const getCeOi = peCoiData.map((item) => item)
    return getCeOi
  }

  const getBuySellData = (divide) => {
    // const divide = gettble2PeCoIdata() / gettble2CeCoIdata()
    if (divide > 1) {
      return <span className='buy-text'> Buy </span>
    } else {
      return <span className='sell-text'> Sell </span>
    }
  }

  const getTable2Data = (value) => {
    let Data = localStorage.getItem("table2Data_" + value);
    // console.log("JSON", JSON.parse(Data))
    return JSON.parse(Data) || []
  }

  // const getTable2Data = [
  //   {
  //     ceOI: gettble2CeCoIdata(),
  //     peOI: gettble2PeCoIdata(),
  //     timeStamp: timeStamp,
  //     peCeRatio: gettble2PeCoIdata() / gettble2CeCoIdata(),
  //     byesell: getBuySellData(),
  //   },
  // ]

  const getTableData = () => {
    const data = filterData.map((item, index) => ({
      srno: index + 1,
      ce: item.CE.changeinOpenInterest,
      pe: item.PE.changeinOpenInterest,
      strikePrice: item.strikePrice,
      ceOI: item.CE.openInterest,
      // ceVolume: ,
      peOI: item.PE.openInterest,
      // peVolume:
    }))

    return data
  }



  // var sum = _.sum(filterData);

  return (
    <div className='App'>
      {/* const { data } = await axios.get(`/api/orders/myorders`, config) */}
      <div className='app-select'>
        <Select
          showSearch
          placeholder='Select'
          optionFilterProp='children'
          onChange={onChange}
          onSearch={onSearch}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          style={{ width: '25%' }}
        >
          <Option value='NIFTY'>NIFTY</Option>
          <Option value='BANKNIFTY'>BANK NIFTY</Option>
        </Select>
        {isSelect && (
          <Tooltip title='refresh' className='select-search'>
            <Button
              shape='circle'
              icon={<ReloadOutlined />}
              onClick={() => getNifty50(selectData)}
            />
          </Tooltip>
        )}
      </div>
      {isSelect && (
        <Row gutter={32}>
          <Col lg={12} md={12}>
            <Table
              columns={columns}
              dataSource={getTableData()}
              pagination={false}
              size='small'
              loading={tableLoading}
              bordered
              title={() => tableHeader()}
              // footer={() => 'Footer'}
              scroll={{ y: 360 }}
              summary={() => (
                <Table.Summary fixed>
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}>
                      {' '}
                      <b> Total</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={1}> </Table.Summary.Cell>
                    <Table.Summary.Cell index={2}>
                      {' '}
                      CE <b> {ceCoi}</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3}> </Table.Summary.Cell>
                    <Table.Summary.Cell index={4}> </Table.Summary.Cell>
                    <Table.Summary.Cell index={5}>
                      {' '}
                      PE <b> {peCoi}</b>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                </Table.Summary>
              )}
            />
          </Col>
          <Col lg={12} md={12}>
            <Table
              columns={columns2}
              dataSource={getTable2Data(selectData)}
              pagination={false}
              size='small'
              bordered
              // footer={() => 'Footer'}
              scroll={{ y: 375 }}
            />
          </Col>
        </Row>
      )}
    </div>
  )
}

export default App
